import { ReactElement, useMemo, useState } from "react";
import { useGetData } from "../hooks/getData";
import { FilterProps } from "../../../../../hooks/filter/typing";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { useFilter } from "../../../../../hooks/filter";
import { formatFilterMain } from "../constans";
import { UserGroupContext } from "../context";


const UserGrouopProvider = ({ children }: { children: ReactElement }) => {

    const filterMainData = useGetData()

    const externalValidation: FilterProps['externalValidation'] = ({
        name,
        value,
        body,
        setFilterData,
    }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) =>
                area.find((e2: any) => e2.value == e.areaId)
            )


            let arrayChilds: any[] = []

            area?.forEach((e: any) => {
                const id = e.value
                const childs = filterMainData.departments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })



            filterMainData.handleItemsByExternal({ name: 'department', value: arrayChilds })
            setFilterData((prev) => ({
                ...prev,
                department: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                department: newDepartments,
            }
        }

        return copyBody
    }

    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [notGroupSelected, setNotGroupSelected] = useState<number[]>([]);
    const [isChecked, setIsChecked] = useState(false)
    const fitlerMain = useFilter({ formatFilter: formatFilterMain, externalValidation })
    const [uuid, setUuid] = useState('')



    const value = useMemo(() => ({
        
        fitlerMain,
        filterMainData,
        selectedIds,
        setSelectedIds,
        notGroupSelected,
        setNotGroupSelected,
        isChecked,
        setIsChecked,
        uuid, 
        setUuid
    }), [ uuid, setUuid, fitlerMain, filterMainData, selectedIds, setSelectedIds, notGroupSelected, setNotGroupSelected, isChecked, setIsChecked ]);

    return (
        <UserGroupContext.Provider value={value}>
            {children}
        </UserGroupContext.Provider>
    );
};

export { UserGrouopProvider };